import { AnyObject, Portal, Space } from "@thenounproject/lingo-core";
import { useMemo, useEffect } from "react";

const sizes = ["16", "32", "48", "180"];

function getIconLink(size: string): HTMLLinkElement | null {
  return document.querySelector<HTMLLinkElement>(`link[sizes="${size}x${size}"]`);
}

function setThemeFavicons(avatars: Space["avatars"]) {
  sizes.forEach((size, idx) => {
    const el = getIconLink(size);
    if (el) {
      // get the url forthe current size
      let url = avatars[`avatar${size}`];
      // If  we don't have that size, fallback to the next  size
      // We added 48 later on but 32 works fine as a placeholder
      if (!url && idx > 0) {
        url = avatars[`avatar${sizes[idx - 1]}`];
      }
      if (url) {
        el.href = url;
      }
    }
  });

  document
    .querySelector('link[rel="shortcut icon"]')
    ?.setAttribute("rel", "shortcut icon-disabled");

  document
    .querySelector('link[rel="icon"][type="image/x-icon"]')
    ?.setAttribute("rel", "icon-disabled");
}

function setDefaultFavicons(defaults: AnyObject) {
  sizes.forEach(size => {
    const el = getIconLink(size);
    if (el) {
      el.href = defaults[size];
    }
  });
  document
    .querySelector('link[rel="shortcut icon-disabled"]')
    ?.setAttribute("rel", "shortcut icon");

  document
    .querySelector('link[rel="icon-disabled"][type="image/x-icon"]')
    ?.setAttribute("rel", "icon");
}

export default function useCustomFavicon(
  space: Pick<Space, "avatars">,
  portal: Pick<Portal, "images">
) {
  const defaults = useMemo(() => {
    return sizes.reduce((acc, size) => {
      const el = getIconLink(size);
      acc[size] = el?.href;
      return acc;
    }, {});
  }, []);

  let _avatars = portal?.images?.avatars?.avatar ? portal.images.avatars : null;
  if (!_avatars) {
    _avatars = space?.avatars?.avatar ? space.avatars : null;
  }
  useEffect(() => {
    if (_avatars) {
      setThemeFavicons(_avatars);
    } else {
      setDefaultFavicons(defaults);
    }
  }, [_avatars, defaults]);
}
